import { Role } from './role';

export class Account {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    role: string;
    jwtToken?: string;
    billToState: string;
    billToZip: string;
    phone: string;
    companyName: string;
    isActive: boolean;
    message: string;
    error: boolean;
    canRunCreditCheck: boolean;
    clientID: number;
}
